import { User } from 'firebase/auth';
import React, { useContext } from 'react';

// @ts-expect-error
export const UserContext = React.createContext<User>();

const useUser = () => useContext(UserContext);

export default useUser;
